const timeOptions = { hour: '2-digit', minute: '2-digit' };

export function formatTime (value) {
  if (!value) return '-';

  const d = new Date(value);
  return d.toLocaleTimeString('en-us', timeOptions);
}
